// Serviço para buscar preview de links
import { PreviewData } from "../interfaces/all";

interface LinkPreviewResponse {
  title?: string;
  description?: string;
  image?: string;
  url: string;
  site_name?: string;
  type?: string;
  status?: "success" | "fail";
}

class LinkPreviewService {
  private readonly API_URL = "https://api.microlink.io";

  async getPreview(url: string): Promise<PreviewData | null> {
    try {
      // Usar microlink.io como serviço de preview
      const response = await fetch(
        `${this.API_URL}?url=${encodeURIComponent(url)}&meta=true`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: LinkPreviewResponse = await response.json();

      if (!data || data.status === "fail") {
        return null;
      }

      return {
        title: data.title || "Link",
        description: data.description || "Clique para abrir o link",
        image: data.image || "",
        url: data.url || url,
      };
    } catch (error) {
      // Fallback para dados básicos se a API falhar
      return {
        title: "Link",
        description: "Clique para abrir o link",
        image: "",
        url: url,
      };
    }
  }

  // Método para extrair metadados básicos de uma URL
  async getBasicPreview(url: string): Promise<PreviewData> {
    try {
      const urlObj = new URL(url);
      return {
        title: urlObj.hostname,
        description: `Link para ${urlObj.hostname}`,
        image: "",
        url: url,
      };
    } catch {
      return {
        title: "Link",
        description: "Clique para abrir o link",
        image: "",
        url: url,
      };
    }
  }
}

export const linkPreviewService = new LinkPreviewService();
